import {Component, Input} from "@angular/core";
import {NgIf} from "@angular/common";


@Component({
	selector: "isf-status",
	standalone: true,
	template: `
        <div class="isf-status">
            <span *ngIf="status=='CREATED'" class="badge status-created small" title="Created and being edited">
                <i class="fa fa-user-plus"></i> Created
            </span>
            <span *ngIf="status=='READY'" class="badge status-ready small" title="Created and passed validation">
                <i class="fa fa-check-square"></i> Ready
            </span>
            <span *ngIf="status=='UPDATED'"
                  class="badge status-updated progress-bar-striped progress-bar-animated small"
                  title="Updated after Acceptance">
                <i class="fa fa-user-plus"></i> Updated
            </span>
            <span *ngIf="status=='TRANSMITTED'" class="badge status-transmitted small" title="Transmitted to CBP">
                <i class="fa fa-hourglass-half"></i> Transmitted
            </span>
            <span *ngIf="status=='ACCEPTED'" class="badge status-accepted small" title="ISF Accepted by CBP">
                <i class="fa fa-check-circle"></i> Accepted
            </span>
            <span *ngIf="status=='REJECTED'" class="badge status-rejected small" title="Rejected by CBP">
                <i class="fa fa-thumbs-down"></i> Rejected
            </span>
            <span *ngIf="status=='REPLACED'" class="badge status-replaced small" title="Replaced">
                <i class="fa fa-recycle"></i> Replaced
            </span>
            <span *ngIf="status=='DELETED'" class="badge status-deleted small"
                  title="Deleted by user & accpepted by CBP">
                <i class="fa fa-minus-circle"></i> Deleted
            </span>
            <span *ngIf="status=='ERROR'" class="badge status-rejected progress-bar-striped progress-bar-animated small"
                  title="Validation Error">
                <i class="fa fa-ban"></i> Error
            </span>
            <span *ngIf="status=='GMS'" class="badge status-gms small" title="ISF pushed to GMS for Entry">
                <i class="fa fa-globe"></i> GMS
            </span>
            <span *ngIf="status=='LOCKED'" class="badge status-locked small" title="Cannot be edited or transmitted">
                <i class="fa fa-lock"></i> Locked
            </span>
        </div>
    `,
	imports: [
		NgIf
	],
	//styleUrls: ["list.css"],
	styles:[`

        .isf-status{}

        .isf-status .badge{
            font-size: 16px;
            padding: 3px;
            width: 100%;
        }

        .isf-status .status-created{
            color: #fff;
            background-color: #9aa0ad;
        }


        .isf-status .status-ready{
            color: #fff;
            background-color: #7b90a2;
        }

        .isf-status .status-transmitted{
            color: #fff;
            background-color: #ff9800;
        }

        .isf-status .status-accepted{
            color: #fff;
            background-color: #5bb44d;
        }

        .isf-status .status-updated{
            color: #fff;
            background-color: #5bb44d;
            border: 2px solid #d7e415;
        }

        .isf-status .status-rejected{
            color: #fff;
            background-color: #d13e46;
        }

        .isf-status .status-replaced{
            color: #fff;
            background-color: #d155b4;
        }

        .isf-status .status-deleted{
            color: #fff;
            background-color: #403f45;
        }

        .isf-status .status-gms{
            color: #fff;
            background-color: #3c85b8;
        }

        .isf-status .status-locked{
            color: #fff;
            background-color: #4c4c4c;
        }
	`]
})
export class ISFSubmissionStatus { @Input() status:string = "CREATED"; }
